//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import download from 'downloadjs';

export default {
    data () {
        return {
            index: 0,
            surveyDialogVisible: false
        };
    },

    computed: {
        stars () {
            return this.$store.getters.stars;
        },
        nickname () {
            return this.$store.getters.nickname;
        },
        avatar () {
            return this.$store.getters.avatar;
        },
        spaceship () {
            return this.$store.getters.getUserSpaceship;
        },
        numBadges () {
            return this.$store.getters.badges.filter(badge => this.$store.getters.hasUserBadge(badge.name)).length;
        },
        gifts () {
            return [
                this.$store.getters.getUserGiftByWeek(1),
                this.$store.getters.getUserGiftByWeek(2),
                this.$store.getters.getUserGiftByWeek(3),
                this.$store.getters.getUserGiftByWeek(4)
            ];
        }
    },

    methods: {
        showSurveyDialog () {
            if (this.$authUser.cannot('classes.manage') && !this.$authUser.is_testuser) {
                this.surveyDialogVisible = true;
            } else {
                this.index++;
            }
        },
        downloadPDF () {
            axios.get('/downloads/certificate', {
                responseType: 'blob'
            }).then(response => {
                download(response.data, 'robitopia_urkunde.pdf', 'application/pdf');
            }).catch(() => {});
        }
    }
};
